export default __webpack_public_path__ + "static/media/3.7257bd0d.svg";